import { render, staticRenderFns } from "./AboutExamination.vue?vue&type=template&id=7625f308&scoped=true"
import script from "./AboutExamination.vue?vue&type=script&lang=js"
export * from "./AboutExamination.vue?vue&type=script&lang=js"
import style0 from "./AboutExamination.vue?vue&type=style&index=0&id=7625f308&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7625f308",
  null
  
)

export default component.exports